var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 125,
    viewBox: "0 0 124 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 87.6362V36.9876C5 19.5049 19.1726 5.33227 36.6554 5.33227H87.3039C104.787 5.33227 118.959 19.5049 118.959 36.9876V87.6362C118.959 105.119 104.787 119.292 87.3039 119.292H36.6554C19.1726 119.292 5 105.119 5 87.6362Z",
    fill: "#FCF9F7",
    stroke: "#4B5E76",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9791 87.6362C75.965 87.6362 87.3034 76.2979 87.3034 62.3119C87.3034 48.3257 75.965 36.9876 61.9791 36.9876C47.9928 36.9876 36.6548 48.3257 36.6548 62.3119C36.6548 76.2979 47.9928 87.6362 61.9791 87.6362Z",
    fill: "#FCF9F7",
    stroke: "#4B5E76",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8013 27.5549L96.8651 27.484L96.8013 27.5549Z",
    fill: "#FCF9F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8013 27.5549L96.8651 27.484",
    stroke: "#4B5E76",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/🦆 icon _instagram_.3e28b932b3ce317d0b2aca701da8144b.svg";
export { ForwardRef as ReactComponent };